document.querySelectorAll('.flip-box').forEach(box => {
    box.addEventListener('click', function () {
        this.classList.toggle('is-flipped');
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const PDP_URL = "https://drinkaegis.com/products/aegis-welcome-kit"; // Replace with your PDP URL

  const init = () => {
    const step1 = document.querySelector(".rc-login [data-rc-step-1]");
    const loginBody = document.querySelector(".rc-login .rc-login--body");

    if (!step1 || !loginBody) return;

    // -----------------------------
    // Note below the login button
    // -----------------------------
    if (!step1.querySelector(".rc-login-note")) {
      const note = document.createElement("p");
      note.className = "rc-login-note";
      note.textContent =
        "Subscribers can manage billing, shipping, and upcoming orders here.";

      step1.appendChild(note);
    }

    // -------------------------------------
    // Link below the white login container
    // -------------------------------------
    if (!document.querySelector(".rc-login-subscribe")) {
      const subscribe = document.createElement("a");
      subscribe.className = "rc-login-subscribe";
      subscribe.href = PDP_URL;
      subscribe.innerHTML =
        'Not a subscriber yet? <span>Subscribe &amp; Save </span>→';

      // Insert after .rc-login--body
      loginBody.insertAdjacentElement("afterend", subscribe);
    }
  };

  init();

  // Recharge renders asynchronously
  const observer = new MutationObserver(init);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});





// For accordion js
const accordion_row = document.querySelectorAll(".accordion-row");
  
function slideToggle(element, duration = 300) {
  if (window.getComputedStyle(element).display === 'none') {
      slideDown(element, duration);
  } else {
      slideUp(element, duration);
  }
  }

  function slideDown(element, duration = 300) {
      element.style.removeProperty('display');
      let display = window.getComputedStyle(element).display;
      if (display === 'none') display = 'block';
      element.style.display = display;

      const height = element.offsetHeight;
      element.style.overflow = 'hidden';
      element.style.height = '0px';
      element.style.paddingTop = '0px';
      element.style.paddingBottom = '0px';
      element.style.marginTop = '0px';
      element.style.marginBottom = '0px';
      element.offsetHeight; // force reflow

      element.style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
      element.style.height = height + 'px';
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');

      window.setTimeout(() => {
          element.style.removeProperty('height');
          element.style.removeProperty('overflow');
          element.style.removeProperty('transition');
      }, duration);
  }

  function slideUp(element, duration = 300) {
      element.style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
      element.style.height = element.offsetHeight + 'px';
      element.offsetHeight; // force reflow

      element.style.overflow = 'hidden';
      element.style.height = '0px';
      element.style.paddingTop = '0px';
      element.style.paddingBottom = '0px';
      element.style.marginTop = '0px';
      element.style.marginBottom = '0px';

      window.setTimeout(() => {
          element.style.display = 'none';
          element.style.removeProperty('height');
          element.style.removeProperty('padding-top');
          element.style.removeProperty('padding-bottom');
          element.style.removeProperty('margin-top');
          element.style.removeProperty('margin-bottom');
          element.style.removeProperty('overflow');
          element.style.removeProperty('transition');
      }, duration);
  }

accordion_row.forEach(row => {
  let accordion_trigger = row.querySelector(".accordion-trigger");
  let accordion_data = row.querySelector(".accordion-data");

  accordion_trigger.addEventListener("click",(e)=>{
      e.preventDefault();

      slideToggle(accordion_data);
      accordion_trigger.classList.toggle("open");
  })
});


const widget_wrapper_el = document.querySelector(".recharge-subscription-widget");

function updateButton_ui() {
  const recharge_config = window.Recharge;
  const btn = document.querySelector(".apw__cta");
  const priceEl = document.querySelector(".rc-radio__price");
  const messageEl = document.querySelector(".rc-radio__subscription");
  // let varient_Id = "";

  if (!btn || !priceEl || !messageEl) return;

  for ( const [key, value] of Object.entries(recharge_config.widgets)){
    // varient_Id = value.config.initialVariantId;

    // const widget = Recharge?.widgets?.[productId];
    const widget_settings = value.widgetSettings;
    const varient_Id = value.config.initialVariantId;
    const varient_config = value.config.formattedVariantPrices[varient_Id]
  
    const subscribeMessage = widget_settings.subscribe_message || messageEl.textContent.trim() || "Subscribe";
    console.log(messageEl)
    
    messageEl.textContent = subscribeMessage;
    
    // Get only the subscription price (ignore compare-at price)
    // const price = priceEl.childNodes[0].textContent.trim();
  
    // Update CTA button
    btn.textContent = `Add to Cart – ${varient_config.discounted}/mo`;

    clearInterval(updateButton_ui_interval);
  }
  
}

let updateButton_ui_interval;

if(widget_wrapper_el){
  updateButton_ui_interval =  setInterval(() => {
    updateButton_ui();
  }, 100);
}


function update_price_label_ui() {
  const recharge_config = window.Recharge;

    for ( const [key, value] of Object.entries(recharge_config.widgets)){
      console.log({key, value});
      const recharge_widget_elem = document.querySelector(`#RechargeWidget_${key}`);
      const varient_Id = value.config.initialVariantId;
      const varient_config = value.config.formattedVariantPrices[varient_Id]
      console.log("varient_Id",varient_Id)
      
      console.log("varient_config",varient_config)
      if(recharge_widget_elem){
        const price_el = recharge_widget_elem.querySelector(".subscription-radio .rc-radio__price");
        const label_el = recharge_widget_elem.querySelector(".subscription-radio .rc-radio__subscription");
        
        if(!price_el || !label_el) return;

        label_el.innerHTML = "Subscribe &amp; Save";
        price_el.innerHTML = `${varient_config.discounted} <span class="price">${varient_config.unit}</span>`;
      }

      clearInterval(update_price_label_ui_interval);
    }

};

let update_price_label_ui_interval;

if(widget_wrapper_el){
  update_price_label_ui_interval =  setInterval(() => {
    update_price_label_ui();
  }, 100);
}


function injectBenefits_list() {
  const container = document.querySelector(".rc-selling-plans");
  
  if (!container) return;

  if (container.querySelector(".subscription-benefits")) return;

  const wrapper = document.createElement("div");
  wrapper.className = "subscription-benefits";

  if (
      typeof window.subscriptionBenefitsHtml === "string" &&
      window.subscriptionBenefitsHtml.trim() !== ""
  ) {
      // Convert HTML string to DOM nodes
      const parser = new DOMParser();
      const doc = parser.parseFromString(window.subscriptionBenefitsHtml, "text/html");

      // Append all parsed nodes
      Array.from(doc.body.childNodes).forEach(node => {
          wrapper.appendChild(node.cloneNode(true));
      });

      console.log("[Benefits] Loaded from window.subscriptionBenefitsHtml");
  }

  container.appendChild(wrapper);
 
  clearInterval(benefits_list_interval);
}

let benefits_list_interval;

if(widget_wrapper_el){
  benefits_list_interval =  setInterval(() => {
    injectBenefits_list();
  }, 100);
}

